import Training from '../training';

/**
 * Create the action
 */

const { thunk, request, success, error } = Training.update((data, fetch) => {
    // Prepare request
    const { id } = data;

    return fetch.post(`/trainings/register/${id}`, data);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
